import { get, put, post, del, default as com } from "@/common/api";

const api = {
  //叫号登录
  callLogin: (para) => {
    return post(`/api/proxy/caller/login`, para);
  },
  //叫号退出
  callLogout: (para) => {
    return post(`/api/proxy/caller/logout`, para);
  },

  queryDeptDoctor: (deptCode) => {
    return get(`/api/op/dept/${deptCode}/doctor`);
    // return get(`/api/op/opDoctor`, deptCode);
  },
  queryDeptRegType: (deptCode) => {
    return get(`/api/op/dept/${deptCode}/RegType`);
  },
  queryRegType: com.queryRegType,
  generateQueues: (para) => {
    // return post('/api/op/opQueue',para);
    return post(`/api/op/line`, para);
  },
  delQueue(id) {
    // return del(`/api/op/opQueue/${code}`)
    return del(`/api/op/line/${id}`);
  },
  queryReg: (para) => {
    return get("/api/op/reg", para);
  },
  queryOpQueue: (para) => {
    // return get('/api/op/opQueue',para);
    return get(`/api/op/line`, para);
  },
  queryOpQueuePatient(id) {
    // return get('/api/op/opQueuePatient', para);
    return get(`/api/op/line/${id}/detail`);
  },
  patientJoinQueue(opNo) {
    // return post('/api/op/opQueuePatient',para);
    return put(`/api/op/line/reg/${opNo}`);
  },
  patientShift(id, toId) {
    return put(`/api/op/line/reg/${id}/before/${toId}`);
  },
  callPatient: (para) => {
    return get("/api/op/opQueuePatient/current", para);
  },
  saveTriageSetting: (para) => {
    return post("/api/op/triageSetting", para);
  },
  getTriageSetting: (deptCode) => {
    return get(`/api/op/triageSetting/${deptCode}`);
  },
  clearDeptQueues: (code) => {
    return del(`/api/op/line/dept/${code}`);
  },
  getDoctorQueues(doctorId) {
    return get(`/api/op/line/doctor/${doctorId}`);
  },
  switchQueueDoctor(id, doctorId) {
    return put(`/api/op/line/${id}/doctor/${doctorId}`);
  },
};

export default api;
